import { ArrowUpRight, Clock3 } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { BlogPost } from '../data/blogs'
import { ArticleVisual } from './ArticleVisual'

export function ArticleCard({ post, featured = false }: { post: BlogPost; featured?: boolean }) {
  return (
    <Link className={`article-card tone-${post.imageTone} ${featured ? 'is-featured' : ''}`} to={`/insights/${post.slug}`}>
      <div className="article-art">
        <ArticleVisual post={post} />
      </div>
      <div className="article-card-body">
        <div className="article-meta"><span>{post.category}</span><span><Clock3 size={14} /> {post.readTime}</span></div>
        <h3>{post.title}</h3>
        <p>{post.excerpt}</p>
        <span className="text-link">Read the guide <ArrowUpRight size={17} /></span>
      </div>
    </Link>
  )
}
